import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetPreferenceResponse,
  PatchUserPreferenceRequest,
} from '../types';

type ApiEnvelope<T> = { data: T };

export const patchUserPreference = async <T extends Record<string, unknown>>(
  params: PatchUserPreferenceRequest<T>,
): Promise<GetPreferenceResponse<T>> => {
  const { boardId, key, data } = params;
  const url = `/api/v2/boards/${boardId}/preferences/${encodeURIComponent(key)}/user`;

  const response = await apiAuthClient.patch<
    ApiEnvelope<GetPreferenceResponse<T>>
  >(url, { data });
  return response.data.data;
};
